import { render, staticRenderFns } from "./SCardInventoryComp.vue?vue&type=template&id=22cfc7e1&"
import script from "./SCardInventoryComp.vue?vue&type=script&lang=js&"
export * from "./SCardInventoryComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports